import { makeApiRequest } from '@/src/lib/api-request'
import { useQuery } from '@tanstack/react-query'
import { useUser } from '@/src/store/user-store'
import { useToken } from '@/src/store/token-store'
import { format } from 'date-fns'

export interface TimeSeriesData {
  t: string
  coins: number
}

export enum TimeFrame {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

const getTimeFrameFromIndex = (index: number): TimeFrame => {
  switch (index) {
    case 0:
      return TimeFrame.DAY
    case 1:
      return TimeFrame.DAY
    case 2:
      return TimeFrame.YEAR
    case 3:
      return TimeFrame.DAY
    default:
      return TimeFrame.DAY
  }
}

export const useEarningCreatorTimeSeries = (
  index: number,
  startDate: Date,
  endDate: Date,
  filterData: string
) => {
  const { user, _hasHydrated } = useUser()
  const { accessToken } = useToken()

  return useQuery({
    queryKey: [
      'earning-time-series',
      user,
      index,
      startDate,
      endDate,
      filterData,
    ],
    queryFn: async () => {
      const response = await makeApiRequest({
        method: 'POST',
        url: '/Earning/getCreatorEarning_graphView',
        isAuthenticated: true,
        data: {
          timeFrame: getTimeFrameFromIndex(index),
          startDate: format(startDate, 'yyyy-MM-dd HH:mm:ss'),
          endDate: format(endDate, 'yyyy-MM-dd HH:mm:ss'),
          filterData: filterData,
        },
        fallbackError: 'Error while fetching time series',
        isV3Api: true,
      })

      return response.response as TimeSeriesData[]
    },
    enabled: !!_hasHydrated && !!accessToken,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
    refetchOnMount: false,
  })
}
